import { Component, Input, OnInit } from '@angular/core';
import { AdminService } from '../../admin/services/admin.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CompanyService } from '../company.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-company-logo',
  templateUrl: './company-logo.component.html',
  styleUrls: ['./company-logo.component.scss']
})
export class CompanyLogoComponent implements OnInit {
  @Input() vc_idCompany: number | null = null;
  vc_logo: Blob | null = null; // Store the selected logo as a Blob
  vc_logoUrl: string | null = null; // Store the preview URL
  vc_originalLogoUrl: string | null = null;
  vc_editMode: boolean = false;
  vc_fileSelected = false;

  constructor(private adminService: AdminService, 
    private sanitizer: DomSanitizer, 
    private companyService: CompanyService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    // this.vc_idCompany = +localStorage.getItem('idCompanyUser');
    this.loadLogo();
  }

  loadLogo(): void {
    if (!this.vc_idCompany) return;
    this.companyService.getCompanyLogo(this.vc_idCompany).subscribe({
      next: (blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.vc_logoUrl = this.vc_originalLogoUrl = reader.result as string; // Convert Blob to Base64 and store in component
        };
        reader.readAsDataURL(blob);
        this.vc_editMode = false;
      },
      error: (err) => {
        console.error("Error fetching company logo:", err);
        this.vc_logoUrl = this.vc_originalLogoUrl = null; // 
        this.vc_editMode = true;
      }
    });
  }

  fn_uploadLogo(event: any): void {
    const file = event.target.files[0];

    if (file) {
      this.resizeImageBlob(file, 300, 150)
        .then((resizedBlob) => {
          this.vc_logo = resizedBlob;
          this.vc_fileSelected = true;

          // Create preview URL
          const reader = new FileReader();
          reader.onload = (e: any) => {
              this.vc_logoUrl = e.target.result; // ✅ Display the preview immediately
          };
          reader.readAsDataURL(resizedBlob); // ✅ Convert Blob to Base64
        })
        .catch((error) => {
          console.error('Error resizing the uploaded logo:', error);
        });
    }
  }

  async saveLogo() {
    if (!this.vc_logo) return;

    const logoFile = new File([this.vc_logo], 'company-logo.png', { type: 'image/png' });

    const formData = new FormData();
    formData.append('file', logoFile);

    (await this.adminService.uploadCompanyLogo(this.vc_idCompany, logoFile)).subscribe({
      next: () => {
        // alert('Logo guardado exitosamente.');
        this.toastrService.success('Logo guardado exitosamente')
        this.companyService.clearCompanyLogoCache(this.vc_idCompany);
        this.vc_fileSelected = false; // Reset file selection flag
        this.vc_editMode = false; // Exit edit mode
        this.loadLogo(); // Refresh logo after upload
      },
      error: (err) => {
        console.error('Error uploading logo:', err);
        this.toastrService.error('Error al subir el logo')
        // alert('Error al subir el logo.');
      }
    });
  }
  
  // fn_clearLogo(): void {
  //   this.vc_logo = null;
  //   this.vc_logoUrl = this.vc_originalLogoUrl;
  //   this.vc_editMode = false; // Exit edit mode
  //   this.vc_fileSelected = false; // Disable "Guardar"
  // }

  fn_enableEditMode(): void {
    this.vc_editMode = true;
    this.vc_logoUrl = null; // Hide old preview
    this.vc_fileSelected = false; // Ensure "Guardar" is disabled
  }

  // Cancels the edit operation
  fn_cancelEdit(): void {
    this.vc_editMode = false; // Exit edit mode
    this.vc_logoUrl = this.vc_originalLogoUrl; // Restore the original logo preview
    this.vc_fileSelected = false; // Reset file selection state
  }

  async fn_deleteLogo() {
    (await this.companyService.deleteCompanyLogo(this.vc_idCompany)).subscribe(
      (response) => {
        this.toastrService.success('Logo eliminado');
        this.companyService.clearCompanyLogoCache(this.vc_idCompany);
        this.vc_fileSelected = false; // Reset file selection flag
        this.vc_editMode = false; // Exit edit mode
        this.loadLogo(); // Refresh logo after upload
        console.log(response);
      }, error => {
        console.error(error);
        this.toastrService.error('Error al eliminar el logo');
      });
  }

  async resizeImageBlob(file: File, maxWidth: number, maxHeight: number): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event: any) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          resolve(file)
        //   if (img.width <= maxWidth && img.height <= maxHeight) {
        //     resolve(file);
        //     return;
        //   }

        //   const canvas = document.createElement('canvas');
        //   let width = img.width;
        //   let height = img.height;

        //   if (width > maxWidth || height > maxHeight) {
        //     const scale = Math.min(maxWidth / width, maxHeight / height);
        //     width *= scale;
        //     height *= scale;
        //   }

        //   canvas.width = width;
        //   canvas.height = height;
        //   const ctx = canvas.getContext('2d');
        //   if (ctx) {
        //     ctx.drawImage(img, 0, 0, width, height);
        //     canvas.toBlob(resolve, 'image/png');
        //   } else {
        //     reject(new Error('Failed to get canvas context'));
        //   }
        };

        img.onerror = reject;
      };

      reader.onerror = reject;
    });
  }

}
